import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, ArrowRight } from 'lucide-react';
import usePageMeta from '../hooks/usePageMeta';

const OurStory = () => {
  usePageMeta({
    title: 'Our Story | Built by Beer-Drinkers, For Beer-Drinkers',
    description: 'No-Belly began with a clean beer wish. Recipe developed with VLB Berlin. Founded by Rahul Dudeja & Garima Mathur — the Couple of Biers.',
    path: '/our-story',
  });

  return (
  <main className="nb-page nb-page-story" data-testid="page-our-story">
    <section className="nb-page-hero">
      <div className="nb-page-hero-inner">
        <p className="nb-eyebrow">OUR STORY</p>
        <h1 className="nb-display-md">BUILT BY BEER-DRINKERS.<br />FOR BEER-DRINKERS.</h1>
        <p className="nb-page-lede">
          No-Belly began with a simple wish — a beer that's clean, crisp and honest.
          No added sugar. No glycerine. No shortcuts.
        </p>
      </div>
    </section>

    <section className="nb-story-block" data-testid="story-origin">
      <div className="nb-story-block-inner">
        <p className="nb-eyebrow">THE ORIGIN</p>
        <h2 className="nb-display-sm">FROM VLB BERLIN TO YOUR GLASS.</h2>
        <p className="nb-copy">
          After two decades in India Inc, Rahul and Garima went back to first principles. They partnered with
          <strong> VLB Berlin</strong> — one of the world's most respected brewing institutes — to develop the
          No-Belly recipe. The mild lager is brewed to the German <em>Reinheitsgebot</em> — water, malt, hops and yeast.
          Nothing else.
        </p>
        <p className="nb-copy">
          Every batch is brewed with imported Pilsner &amp; Munich malts, organic Magnum hops and
          soft natural spring water. And every bottle carries the same promise: no added sugar,
          no glycerine, no artificial preservatives.
        </p>
      </div>
    </section>

    <section className="nb-founders" data-testid="story-founders">
      <header className="nb-section-head">
        <p className="nb-eyebrow">THE FOUNDERS</p>
        <h2 className="nb-display-md">THE COUPLE OF BIERS.</h2>
      </header>
      <div className="nb-founders-row">
        <figure className="nb-founder" data-testid="story-founder-rahul">
          <img src="/team/rahul.jpg" alt="Rahul Dudeja" />
          <figcaption>
            <strong>Rahul Dudeja</strong>
            <span>Founder &amp; CEO</span>
          </figcaption>
          <a href="https://www.linkedin.com/in/rahul-dudeja-56610823/" target="_blank" rel="noopener noreferrer"
            className="nb-cta-ghost nb-cta-sm" data-testid="story-linkedin-rahul">
            <Linkedin size={14} /> LinkedIn
          </a>
        </figure>
        <p className="nb-founder-story">
          Two decades across brands, distribution and hospitality. Rahul leads product, brewing and
          expansion — obsessing over every batch, every retailer, every pour.
        </p>
        <figure className="nb-founder" data-testid="story-founder-garima">
          <img src="/team/garima.png" alt="Garima Mathur" />
          <figcaption>
            <strong>Garima Mathur</strong>
            <span>Co-Founder &amp; CMO</span>
          </figcaption>
          <a href="https://www.linkedin.com/in/garima-mathur-2551a396/" target="_blank" rel="noopener noreferrer"
            className="nb-cta-ghost nb-cta-sm" data-testid="story-linkedin-garima">
            <Linkedin size={14} /> LinkedIn
          </a>
        </figure>
      </div>
    </section>

    <section className="nb-story-mission" data-testid="story-mission">
      <div className="nb-story-mission-inner">
        <p className="nb-eyebrow">THE MISSION</p>
        <h2 className="nb-display-sm">GET THE BUZZ. SKIP THE BELLY.</h2>
        <p className="nb-copy">
          No-Belly is for people who love beer but hate the compromise — the bloat, the sugar,
          the guilt. We're building a beer that fits the way you live: light on the belly,
          heavy on flavour.
        </p>
        <div className="nb-story-ctas">
          <Link to="/our-beer" className="nb-cta-primary" data-testid="story-cta-beer">See Our Beer<ArrowRight size={16} /></Link>
          <Link to="/find-us" className="nb-cta-ghost" data-testid="story-cta-find">Find No-Belly Near You</Link>
        </div>
      </div>
    </section>
  </main>
  );
};

export default OurStory;
